"use strict";
exports.__esModule = true;
var currencies_1 = require("../../currencies");
// ETH BTC is a special case to handle
// no exchange support BTC->ETH but then do ETH->BTC
// so when user chose ETH as countervalues we need to actually ask ETH->BTC reverse the rate
var ETH = (0, currencies_1.getCryptoCurrencyById)("ethereum");
var BTC = (0, currencies_1.getCryptoCurrencyById)("bitcoin");
var remap = function (pair) {
    return pair.from === BTC && pair.to === ETH
        ? {
            from: ETH,
            to: BTC
        }
        : pair;
};
var mapRate = function (pair, rate) {
    return pair.from === BTC && pair.to === ETH ? 1 / rate : rate;
};
var mod = {
    aliasPair: remap,
    resolveTrackingPair: remap,
    mapRate: mapRate
};
exports["default"] = mod;
//# sourceMappingURL=ethbtc.js.map